import React from "react";

const AssetFormButtonGroup = ({ t, isLoading, navigate }) => (
  <div className="flex gap-2 items-center mb-2">
    <button
      variant="primary"
      type="button"
      onClick={() => navigate("/dashboard")}
      className="bg-gray-200 text-black px-4 py-2 -md text-sm sm:text-base w-full sm:w-auto"
    >
      {t("common.cancel")}
    </button>
    <button
      variant="primary"
      type="submit"
      className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 text-sm sm:text-base w-full sm:w-auto ${
        isLoading ? "opacity-50 cursor-not-allowed" : ""
      }`}
      disabled={isLoading}
    >
      {t("common.buttons.save")}
    </button>
  </div>
);

export default AssetFormButtonGroup;